import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const configuration = _configuration

export const auditTrailTypes = {
    auditTrail: "audit_trail",
}

export const targetTypes = {
    auditTrail: "audit_trail",
}

export const auditTargetTypes = {
    document: {
        id: "document",
        value: "document",
        display: "Document"
    },
    repository: {
        id: "repository",
        value: "repository",
        display: "Repository"
    },
    item: {
        id: "item",
        value: "item",
        display: "Item"
    },
    user: {
        id: "user",
        value: "user",
        display: "User"
    },

}

export const moduleTypes = {
    document: {
        deliveryOrder: {
            id: "delivery",
            value: "delivery",
            display: "Delivery Order",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        salesOrder: {
            id: "sales",
            value: "sales",
            display: "Sales Order",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        cashSales: {
            id: "cash_sales",
            value: "cash_sales",
            display: "Cash Sales",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        salesInvoice: {
            id: "sales_invoice",
            value: "sales_invoice",
            display: "Sales Invoices",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        retailCashSales: {
            id: "retail_cash_sales",
            value: "retail_cash_sales",
            display: "Retail Cash Sales",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        replacementDelivery: {
            id: "replacement_delivery",
            value: "replacement_delivery",
            display: "Replacement Delivery",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        salesDebitNotes: {
            id: "sales_debit_note",
            value: "sales_debit_note",
            display: "Sales Debit Notes",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        salesCreditNotes: {
            id: "sales_credit_note",
            value: "sales_credit_note",
            display: "Sales Credit Notes",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        purchase: {
            id: "purchase",
            value: "purchase",
            display: "Purchases",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        purchaseInvoice: {
            id: "purchase_invoice",
            value: "purchase_invoice",
            display: "Purchase Invoice",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        purchaseReturn: {
            id: "purchase_return",
            value: "purchase_return",
            display: "Purchase Return",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
        itemReceive: {
            id: "item_receive",
            value: "item_receive",
            display: "Item Receive",
            target: auditTargetTypes.document.id,
            trailRef: "document"
        },
    },
    documentItem: {
        deliveryOrder: {
            id: "delivery",
            value: "",
            display: "Delivery Order",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        salesOrder: {
            id: "sales",
            value: "sales",
            display: "Sales Order",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        cashSales: {
            id: "cash_sales",
            value: "cash_sales",
            display: "Cash Sales",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        salesInvoice: {
            id: "sales_invoice",
            value: "sales_invoice",
            display: "Sales Invoices",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        retailCashSales: {
            id: "retail_cash_sales",
            value: "retail_cash_sales",
            display: "Retail Cash Sales",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        replacementDelivery: {
            id: "replacement_delivery",
            value: "replacement_delivery",
            display: "Replacement Delivery",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        salesDebitNotes: {
            id: "sales_debit_note",
            value: "sales_debit_note",
            display: "Sales Debit Notes",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        salesCreditNotes: {
            id: "sales_credit_note",
            value: "sales_credit_note",
            display: "Sales Credit Notes",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        purchase: {
            id: "purchase",
            value: "purchase",
            display: "Purchases",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        purchaseInvoice: {
            id: "purchase_invoice",
            value: "purchase_invoice",
            display: "Purchase Invoice",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        purchaseReturn: {
            id: "purchase_return",
            value: "purchase_return",
            display: "Purchase Return",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
        itemReceive: {
            id: "item_receive",
            value: "item_receive",
            display: "Item Receive",
            target: auditTargetTypes.document.id,
            trailRef: "document_item"
        },
    },
    item: {
        product: {
            id: "product",
            value: "product",
            display: "Product",
            target: auditTargetTypes.item.id,
            trailRef: "item"
        },
        item: {
            id: "item",
            value: "item",
            display: "Item",
            target: auditTargetTypes.item.id,
            trailRef: "item"
        }
    },
    repository: {
        package: {
            id: "package",
            value: "package",
            display: "Package",
            target: auditTargetTypes.repository.id,
            trailRef: "repository"
        },
        container: {
            id: "container",
            value: "container",
            display: "Container",
            target: auditTargetTypes.repository.id,
            trailRef: "repository"
        },
    },
    repositoryItem: {
        package: {
            id: "package",
            value: "package",
            display: "Package",
            target: auditTargetTypes.repository.id,
            trailRef: "repository_item"
        },
        container: {
            id: "container",
            value: "container",
            display: "Container",
            target: auditTargetTypes.repository.id,
            trailRef: "repository_item"
        },
    },
    user: {
        administrator: {
            id: "administrator",
            value: "administrator",
            display: "Administrator",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
        supplier: {
            id: "supplier",
            value: "supplier",
            display: "Supplier",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
        retailer: {
            id: "retailer",
            value: "retailer",
            display: "Retailer",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
        customer: {
            id: "customer",
            value: "customer",
            display: "Customer",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
        driver: {
            id: "driver",
            value: "driver",
            display: "Driver",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
        worker: {
            id: "worker",
            value: "worker",
            display: "Worker",
            target: auditTargetTypes.user.id,
            trailRef: "user"
        },
    },
    branch: {
        customer: {
            id: "customer",
            value: "customer",
            display: "Customer",
            target: auditTargetTypes.user.id,
            trailRef: "branch"
        },
        retailer: {
            id: "retailer",
            value: "retailer",
            display: "Retailer",
            target: auditTargetTypes.user.id,
            trailRef: "branch"
        }
    },
    branchUser: {
        customer: {
            id: "customer",
            value: "customer",
            display: "Customer",
            target: auditTargetTypes.user.id,
            trailRef: "branch_user"
        },
        retailer: {
            id: "retailer",
            value: "retailer",
            display: "Retailer",
            target: auditTargetTypes.user.id,
            trailRef: "branch_user"
        }
    },
    member: {
        retailer: {
            id: "retailer",
            value: "retailer",
            display: "Retailer",
            target: auditTargetTypes.user.id,
            trailRef: "member"
        }
    }
}

export function useAuditTrails({
    auditTrailType: _auditTrailType, 
    targetType: _targetType
}) {

    const [auditTrailType, setAuditTrailType] = useState(_auditTrailType);
    const [targetType, setTargetType] = useState(_targetType)
    // const [actionType, setActionType] = useState(_actionType)

    const { makeCall, serverClient, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "audit_trails";
    const endpoint2 = "audit_trail";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            let { auditTrailType: overrideAuditTrailType } = props

            let url = getListsUrl(`${endpoint}/${auditTrailType}`, props)

            if (overrideAuditTrailType) {
                url = getListsUrl(`${endpoint}/${overrideAuditTrailType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;
            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true

    }

    const create = async ({ data }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // const update = async ({
    //     id,
    //     data,
    //     targetType: overrideTargetType,
    //     actionType: overrideActionType
    // }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = `${endpoint2}/${id}`

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: actionType,
    //             },
    //             payload: data
    //         }

    //         if (overrideTargetType) postData.scope.target = overrideTargetType
    //         if (overrideActionType) postData.scope.action = overrideActionType

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }


    // const modify = async ({ id, data }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = `${endpoint2}/${id}`

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            // let url = `${endpoint}/${auditTrailType}/delete`
            let url = `${endpoint}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, auditTrailType: overrideAuditTrailType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${auditTrailType}/${id}`, dataTypesArray);

            if (overrideAuditTrailType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideAuditTrailType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        get,
        create,
        // update,
        // modify,
        remove
    }
}